//Auto Logout Service File

import { Injectable,Compiler } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../services/local-storage';
import {Observable} from 'rxjs/Observable';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import { SharedService } from '../services/shared.service';
import { LoaderService } from '../services/Spinner.service';
import { Router, ActivatedRoute } from '@angular/router';
@Injectable()
export class autologout {
    idleState = 'Not started.';
    timedOut = false;
    token;
    constructor(private localstorage : LocalStorage, private idle: Idle, private keepalive: Keepalive, private _SharedService: SharedService, private router : Router,private _compiler: Compiler) {
       
    }
    
    init() {


        this.idle.setIdle(7200);
        // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
        this.idle.setTimeout(10);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      
        this.idle.onIdleEnd.subscribe(() => {
            this.idleState = 'No longer idle.'
            console.log("this.idleState"+this.idleState)
        });

        this.idle.onTimeout.subscribe(() => {
          this.idleState = 'Timed out!';
          this.timedOut = true;
          this.token=this.localstorage.getStorage('token'); 
  if(window.location.href.indexOf("advertiser") > -1){
          this._SharedService.callApiWithToken("adv/profile/signOut",null,this.token).subscribe((result) => {
            if(result && result.data.status){
            this.localstorage.removeStorage('token');
            this.localstorage.removeStorage('start');
            this.localstorage.removeStorage('selectedSegements');
            this.localstorage.removeStorage('usertype');
            this.localstorage.removeStorage('campaignId');
             this.localstorage.removeStorage("payreceipt");
             this.localstorage.removeStorage("pay");
                       

            this.localstorage.clearAll();
             this.idle.clearInterrupts();
             this.idle.ngOnDestroy();
             this.router.navigate(['advertiser/adlogin']);
        
         window.location.reload();
            } 
            // this.loaderService.displayLoader(false);
        });
  }
  else if(window.location.href.indexOf("users") > -1){
        this._SharedService.callApiWithToken("user/profile/logout",null,this.token).subscribe((result) => {
            if(result && result.data.status){
            this.localstorage.removeStorage('token');
            this.localstorage.removeStorage('start');
            this.localstorage.removeStorage('selectedSegements');
            this.localstorage.removeStorage('usertype');
            this.localstorage.removeStorage('campaignId');
             this.localstorage.removeStorage("payreceipt");
             this.localstorage.removeStorage("pay");
           
            this.localstorage.clearAll();
             this.idle.clearInterrupts();
             this.idle.ngOnDestroy();
             this.router.navigate(['users/login']);
        
         window.location.reload();
                                      this._compiler.clearCache();
            } 
            // this.loaderService.displayLoader(false);
        });
  }

  else if(window.location.href.indexOf("admin") > -1){
 this._SharedService.callApiWithToken("admin/adminLogout",null,this.token).subscribe((result) => {
            if(result && result.data.status){
            this.localstorage.removeStorage('token');
            this.localstorage.clearAll();
             this.idle.clearInterrupts();
             this.idle.ngOnDestroy();
             this.router.navigate(['admin/login']);
        
         window.location.reload();
            }
            });
  }
        });
        this.idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');
        this.idle.onTimeoutWarning.subscribe((countdown) => this.idleState = 'You will time out in ' + countdown + ' seconds!');
        this.keepalive.interval(30);
        this.reset();  
    }
    reset() {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
      }
}


// WEBPACK FOOTER //
// ./src/app/services/autologout.service.ts